module.exports = __webpack_public_path__ + "static/headerphone-looped-56e805daaf5b2dc6580c2c3a920010e6.mp4";